const DictionaryModule = () => import(/* webpackChunkName: "DictionaryModule" */ './containers/DictionaryGrid');
const EntryModule = () => import(/* webpackChunkName: "EntryModule" */ './containers/EntryGrid');

export const dictionaryRouting = [
    {path: '/dictionary', name: 'dictionary-list', component: DictionaryModule},
    {path: '/dictionary/:entry', name: 'dictionary-entry', component: EntryModule},
]
